import * as angular from 'angular';

/** @see https://stackoverflow.com/a/13320016 */
export interface Debounce {
    (
        fn: Function,
        waitMillis: number,
        immediate: boolean
    ): () => angular.IPromise<any>;
    (fn: Function, waitMillis: number): () => angular.IPromise<any>;
}

function getDebounceInstance(
    $q: angular.IQService,
    $timeout: angular.ITimeoutService
): Debounce {
    return (
        fn: Function,
        waitMillis: number,
        immediate: boolean = false
    ): (() => angular.IPromise<any>) => {
        let timeout;
        let deferred = $q.defer();
        return function (): angular.IPromise<any> {
            const context = this,
                args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) {
                    deferred.resolve(fn.apply(context, args));
                    deferred = $q.defer();
                }
            };
            const callNow = immediate && !timeout;
            if (timeout) {
                $timeout.cancel(timeout);
            }
            timeout = $timeout(later, waitMillis);
            if (callNow) {
                deferred.resolve(fn.apply(context, args));
                deferred = $q.defer();
            }
            return deferred.promise;
        };
    };
}

angular.module('app').factory('debounce', getDebounceInstance);
